{
  "title": "Mold Earth",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "Transmutation cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "S",
  "duration": "Instantaneous or 1 hour",
  "description": [
    "You choose a portion of dirt or stone that you can see within range and that fits within a 5-foot cube. You manipulate it in one of the following ways:",
    "If you target an area of loose earth, you can instantaneously excavate it, move it along the ground, and deposit it up to 5 feet away. This movement doesn’t have enough force to cause damage.",
    "You cause shapes, colors, or both to appear on the dirt or stone, spelling out words, creating images, or shaping patterns. The changes last for 1 hour.",
    "If the dirt or stone you target is on the ground, you cause it to become difficult terrain. Alternatively, you can cause the ground to become normal terrain if it is already difficult terrain. This change lasts for 1 hour.",
    "If you cast this spell multiple times, you can have no more than two of its non-instantaneous effects active at a time, and you can dismiss such an effect as an action."
  ],
  "spellLists": ["druid", "eldritch-knight", "arcane-trickster", "sorcerer", "wizard"]
}
